import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesServicesPhotoMain } from './modules/ui/Main';

const ServicesPhotoPage = (
  <SuspensePage>
    <PagesServicesPhotoMain />
  </SuspensePage>
);

export default ServicesPhotoPage;
